export class AuthorisationStrategy {
  public appConfig: any;
  public onAuthorizationFailed: (response?: any) => void;
  public onForbidden: (error: any, companyId?: number, url?: string) => void;
  public onUnauthorized: (error: any) => void;
}
